export const worldThreeTiles = [
  [33, 21, 21, 21, 20, 20, 20, 21,21, 21, 20, 20, 20, 32, 49, 31,  20, 20, 20, 29],
  [31, 11, 11, 11, 10, 10, 10, 11, 11, 11, 10, 10, 10,  32, 49, 31, 10, 10, 10, 30],
  [31, 1 , 1 , 2 ,1,1,1 , 1 , 2 , 2 , 1 , 1 , 2 ,32, 49, 31, 45 , 46 , 46 , 32 ],
  [31, 1 , 1 , 1 , 2 , 1 , 5 , 6 ,  1,1,1, 1,  1 ,  32, 49, 31, 45, 45, 7, 32],
  [31, 1, 1, 1, 2, 29,  24, 33,  7, 1, 1, 1, 4,  32, 49, 31, 3, 0, 6, 32],
  [33, 1,  5, 2, 1,32, 49, 31, 6, 1, 1, 1, 1,  30, 24, 39, 1, 1, 46, 32],
  [31, 2 , 3 , 5 , 2 , 32, 49, 31,  1, 1,  1, 2, 1, 1, 5, 3, 0, 3, 3, 32],
  [24, 24, 24, 24, 33,32, 49, 31, 1, 1, 1, 2, 1, 29, 24,33, 1, 45, 46, 32],
  [49, 49, 49, 49, 31,32, 49, 31,  24, 24, 24, 24, 24, 32, 49, 31, 24, 24, 24, 32],
  [49, 49, 49, 49, 31,32, 49, 31, 49, 49, 49, 49, 49, 32, 49, 31, 49, 49, 49, 32]
];

//20 wide 60 tall map

//0 represents walkable land.
//6 is blocked land.

//Other numbers will be assigned to intractable tile
